// const initialState = {
//     droits: [],
//   };
//   export default function (state = initialState, action) {
//     switch (action.type) {
//       case "Droits_SELECT":
//         return {
//           ...state,
//           droits: action.payload,
//         };
//       default:
//         return state;
//     }
//   }
  


// redux/reducers/droitsReducer.js

const initialState = {
  data: [],
};

export default function droitsReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_DROITS":
      return {
        ...state,
        data: action.payload, // ✅ stocke ici
      };

    default:
      return state;
  }
}